import { Colors, Styles } from "../preset.constants";

export const textareaPreset = {
    background: Colors.PrimaryBackground,
    color: Colors.DefaultTextColor,
    border: {
        color: Colors.BorderColor,
        radius: Styles.BorderRadiusSM
    },
    disabled: {
        background: Colors.DisabledBackground,
        color: Colors.DisabledColor
    }
}